import { SVGAttributes } from 'react'

export default function SignageIcon(attributes: SVGAttributes<SVGSVGElement>): JSX.Element {
	return (
		<svg {...attributes} fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
			<path className="text-gray-800" d="M32 64c17.673 0 32-14.327 32-32C64 14.327 49.673 0 32 0 14.327 0 0 14.327 0 32c0 17.673 14.327 32 32 32z" fill="currentColor"/>
			<path className="text-white" d="M39.4 13.5L27.2 44.4l12.2-1.5V13.5z" fill="currentColor"/>
			<path className="text-gray-300" d="M40.8 47.6l.1-35.3-14.3-3.2h-1.8v40l-3.9.8v.8l8.1 2.2 15.7-3.7v-.8l-3.9-.8zm-1.4-5.1v.5l-12.2 1.5V11.1l12.2 2.4v29z" fill="currentColor"/>
			<path className="text-green-400" d="M27.2 44.4l12.2-30.9-12.2-2.4v33.3z" fill="currentColor"/>
		</svg>
	)
}
